import Button from '../button/Button';

import { useToast } from '@/hooks/useToast';
import { useUnifiedApiPostSupport } from '@/client/features/mailboxes/services/postSupport';
import {
  buildPremiumTrialFormData,
  UPSELL_REQUEST_FAILED,
  UPSELL_REQUEST_SENT,
} from '@/client/features/mailboxes/utils/premiumTrialRfi';

const UpsellAction = () => {
  const { createToast } = useToast();
  const { mutate: sendRequest, isPending: isSending } = useUnifiedApiPostSupport();

  const onRequestUpgrade = () => {
    sendRequest(buildPremiumTrialFormData(), {
      onSuccess: () => {
        createToast(UPSELL_REQUEST_SENT, 'success');
      },
      onError: () => {
        createToast(UPSELL_REQUEST_FAILED, 'error');
      },
    });
  };

  return (
    <Button disabled={isSending} onClick={onRequestUpgrade}>
      Request access
    </Button>
  );
};

export default UpsellAction;
